import { compact, concat, some } from 'lodash';

import { ActionTypes } from './constants';
import updateQueryParameters from './updateQueryParameters';
import { getSearchParameters } from '../state';

const keysToIgnoreChangesFor = [
    'pageOffset',
    'pickerErrorOverride',
];

/**
 *
 * @param {Object} parameters
 * @param {boolean} shouldSearch
 * @param {boolean} resetFacets clears out facet filters ex) when updating search bar
 */
const updateParameters = (parameters = {}, {
    shouldSearch = true,
    resetFilters = false,
} = {}) =>
    (dispatch, getState) => {
        const nextState = {
            pickerErrorOverride: false,
            ...parameters,
        };
        const prevState = getSearchParameters(getState());

        const paramsOtherThanIgnoredAreDifferent = some(nextState, (value, key) => {
            return !keysToIgnoreChangesFor.includes(key) && prevState[key] !== undefined && value !== prevState[key];
        });

        if (paramsOtherThanIgnoredAreDifferent) {
            nextState.pageOffset = 0;
        }

        const excludeSpecialties = compact(concat(prevState.excludeSpecialties, nextState.excludeSpecialties));
        if (excludeSpecialties.length) {
            nextState.excludeSpecialties = excludeSpecialties;
        }

        nextState.filters = {
            ...prevState.filters,
            ...parameters.filters,
        };

        dispatch({
            type: ActionTypes.UPDATE_PARAMETERS,
            payload: {
                ...prevState,
                ...nextState,
            },
        });

        if (resetFilters) {
            dispatch({ type: ActionTypes.RESET_FILTERS });
        }

        if (shouldSearch) {
            return dispatch(updateQueryParameters());
        }
    };

export default updateParameters;
